export const AUTH_CONSTANTS = Object.freeze({
    LOGIN: "AUTH__LOGIN", VERIFY_LOGIN_CODE: "AUTH__VERIFY_LOGIN_CODE",
    RESEND_LOGIN_CODE: "AUTH__RESEND_LOGIN_CODE", FORGOT_PASSWORD: "AUTH__FORGOT_PASSWORD",
    RESET_PASSWORD: "AUTH__RESET_PASSWORD", CHANGE_PASSWORD: "AUTH__CHANGE_PASSWORD",
    VERIFY_PASSWORD: "AUTH__VERIFY_PASSWORD", ME: "AUTH__ME", REFRESH_TOKEN: "AUTH__REFRESH_TOKEN",
});

export const API_LOAD_ENDPOINTS = Object.freeze({
    AUTH__LOGIN: "/auth/login", AUTH__VERIFY_LOGIN_CODE: "/auth/verify-login-code",
    AUTH__RESEND_LOGIN_CODE: "/auth/resend-login-code", AUTH__FORGOT_PASSWORD: "/auth/forgot-password",
    AUTH__RESET_PASSWORD: "/auth/reset-password", AUTH__CHANGE_PASSWORD: "/auth/change-password",
    AUTH__VERIFY_PASSWORD: "/auth/verify-password", AUTH__ME: "/users/me", AUTH__REFRESH_TOKEN: "/auth/refresh",
});
